export const i18n_vi = {
  product: "Sản phẩm",
  letushelp: "Hãy để chúng tôi giúp bạn",
  registerforfreesupport: "Đăng ký thông tin tại đây để nhận tư vấn miễn phí",
  fullname: "Họ và tên",
  prephone: "Mã số điện thoại",
  phonenumber: "Số điện thoại",
  email: "Email",
  promotionCode: "Mã khuyến mãi",
  promotionCodeNotExisted: "Mã khuyến mãi không tồn tại hoặc đã hết hạn sử dụng",
  promotionCodeMatchLimit: "Mã khuyến mãi đã hết lượt sử dụng",
  customerphlalready: "Tôi đã là khách hàng của Phú Hưng Life",
  interestinphl: "Tôi đang quan tâm sản phẩm/ dịch vụ Phú Hưng Life",
  ponumber: "Số hợp đồng bảo hiểm",
  choosetopic: "Chọn chủ đề quan tâm",
  iagreewith: "Tôi đồng ý với ",
  securityrule: "Điều khoản bảo mật",
  ofPHL: " của Phú Hưng Life",
  registernow: "ĐĂNG KÝ NGAY",
  cs: "Tổng đài CSKH",
  csphone: "(028) 3873 2189",
  // home
  homesteptitle: "MUA BẢO HIỂM TRỰC TUYẾN BỐN BƯỚC",
  homestep1: "Chọn sản phẩm phù hợp",
  homestep2: "Xem phí và quyền lợi",
  homestep3: "Điền thông tin cá nhân",
  homestep4: "Thanh toán trực tuyến nhanh chóng",

  homelistproducttitle: "DANH MỤC SẢN PHẨM",

  homecontactimage: "Tư vấn vui lòng liên hệ",
  homecontacttitle: "Hãy để chúng tôi giúp bạn",
  homecontactdesctitle: "Đăng ký thông tin tại đây để nhận tư vấn miễn phí",

  // product
  productfilldesc: "Vui lòng điền các thông tin sau để xem phí bảo hiểm",
  dob: "Ngày sinh",
  gender: "Giới tính",
  ireadandagreewith: "Tôi đã đọc và đồng ý với ",
  securitypolicy: "Chính sách bảo mật thông tin",
  personaldataprocessingpolicy: "Chính sách xử lý dữ liệu cá nhân",
  concurrentPHL: "Thỏa thuận cung cấp sản phẩm bảo hiểm trên môi trường mạng của Phú Hưng Life",
  understandfollowpolicy: "Theo đó, tôi hiểu rằng các dữ liệu cá nhân tôi cung cấp sẽ được thực hiện theo chính sách này.",
  viewfeepolicy: "Xem phí bảo hiểm",
  productruledetails: "Chi trả 100% Số tiền bảo hiểm nếu Người được bảo hiểm mắc phải Bệnh hiểm nghèo được quy định tại Danh mục bệnh hiểm nghèo: Ung thư đe dọa tính mạng, Nhồi máu cơ tim, Bỏng nặng, Hôn mê, Suy thận, Bệnh Alzheimer, U não lành tính, Ghép cơ quan chính, Bệnh loạn dưỡng cơ, Bệnh Parkinson.",
  policybenefit: "Quyền lợi bảo hiểm",
  productinformation: "Thông tin sản phẩm",
  productinformation1: "Tuổi tham gia: từ 18 đến 60 tuổi.",
  productinformation2: "Tuổi tối đa khi kết thúc thời hạn hợp đồng: 65 tuổi.",
  productinformation3: "Thời hạn hợp đồng: 01 năm và tái tục hàng năm (tối đa 04 lần tái tục).",
  productinformation4: "Thời hạn đóng phí: bằng với Thời hạn hợp đồng bảo hiểm.",
  productinformation5: "Định kỳ đóng phí: hàng năm.",
  productinformation6: "Thời gian chờ: 90 ngày tính từ Ngày hiệu lực của Sản phẩm Bảo hiểm hoặc từ Ngày khôi phục hiệu lực của Hợp đồng bảo hiểm gần nhất (lần sau cùng), tùy vào ngày nào đến sau.",
  productreferences: "Tài liệu tham khảo",
  producttnc: "Quy tắc và Điều khoản sản phẩm",
  referenceinfor: "Tài liệu giới thiệu sản phẩm",
  referencebenefit: "Tài liệu minh họa quyền lợi sản phẩm",
  referencefee: "Biểu phí",

  moneypolicy: "Số tiền bảo hiểm",
  buynow: "Mua ngay",
  vnd: "đồng",
  peryear: "/năm",
  feepolicy: "Phí bảo hiểm",
  yes: "Có",
  no: "Không",
  agree: "Đồng ý",
  disagree: "Không đồng ý",
  continue: "Tiếp tục",
  return: "Quay lại",

  // form-submit
  healthassessment: "Thẩm định sức khỏe",
  fillpersoninfo: "Điền thông tin cá nhân",
  confirminfo: "Xác nhận thông tin",
  payfeeassurence: "Thanh toán phí bảo hiểm",
  healthinfotitle: "Thông tin sức khỏe:",
  fatcainfortitle: "Thông tin FATCA",
  pleaseconfirmtitle: "Hãy xác nhận:",
  inforpoequalinforlatitle: "Thông tin cá nhân của Bên mua bảo hiểm, cũng là Người được bảo hiểm",
  inforpoequalinforladesc: "Các thông tin bên dưới dùng cho việc thẩm định, phát hành hợp đồng bảo hiểm và sẽ được bảo mật. Do đó, bạn hãy điền đầy đủ và chính xác các thông tin này.",


  // footer
  footerproduct: "Sản phẩm bảo hiểm",
  footerproduct1: "Phú Hưng Đại Phúc",
  footerproduct2: "Phú Hưng Đại Phát",
  footerproduct3: "Phú Hưng An Gia",
  footerproduct4: "Phú Hưng Trí Việt",
  footerproduct5: "Phú Bảo An Gia",
  footerproduct6: "Sản phẩm Bổ Trợ",
  footerproductnew1: "Phú Hưng Vẹn Toàn",
  footerproductnew2: "Sản phẩm bán kèm",
  footerproductnew3: "Tài liệu tham khảo",
  footercs: "Dịch vụ khách hàng",
  footercs1: "Thông tin lãi suất và Quỹ liên kết",
  footercs2: "Yêu cầu liên quan đến hợp đồng bảo hiểm",
  footercs3: "Giải quyết quyền lợi bảo hiểm",
  footercs4: "Phương thức đóng phí và Hướng dẫn thanh toán",
  footercs5: "Chương trình Khách hàng VIP",
  footercs6: "Biểu mẫu thông dụng",
  footercs7: "Các câu hỏi thường gặp",
  footercs8: "Tra cứu văn phòng",
  contact: "Liên hệ",
  contact1: "Hotline: (028) 3873 2189",
  contact2: "Fax: (028) 5413 6995",
  contact3: "Địa chỉ: Tầng 20, Tòa nhà Phú Mỹ Hưng, 08 Hoàng Văn Thái, phường Tân Phú, Quận 7, Tp. Hồ Chí Minh",
  contact4: "Email: customer.service@phuhunglife.com",
  copyright: "Copyright © 2025 Phu Hung Life. All rights Reserved",
  copyrightpolicy: "Giấy phép số 69/GP/KDBH do Bộ Tài Chính cấp ngày 30/08/2013",

  contactnew1: "Hotline: 1900 886 838",
  contactnew3: "Địa chỉ: Tầng 20, Tòa nhà Phú Mỹ Hưng, 08 Hoàng Văn Thái, Phường Tân Mỹ, Tp. Hồ Chí Minh",




  nullfullname: "Họ và tên trống",
  nullbirth: "Ngày sinh trống",
  nullgender: "Giới tính trống",
  nullphone: "Số điện thoại trống",
  nullprefixphone: "Mã số điện thoại trống",
  nullpoNumber: "Số hợp đồng bảo hiểm trống",
  nullChoiceCus: "Vui lòng chọn nhu cầu",
  nullChoiceTopic: "Vui lòng chọn chủ đề",
  nullnotemessage: "Lời nhắn cho Phú Hưng Life trống",
  nullemail: "Email trống",
  wrongformatphone:"Số điện thoại không đúng định dạng, vui lòng kiểm tra lại.",
  seemoreproduct: "Xem thêm sản phẩm khác",
  nullphoneotp: "Vui lòng nhập mã otp để tiếp tục",

  pleasefill: "Vui lòng điền thông tin",
  fullnamefill: "Họ và tên (Gõ tiếng Việt có dấu):",
  birthfill: "Ngày sinh:",
  genderfill: "Giới tính:",
  genderchoosefill: "Nam / Nữ",
  gendermale: "Nam",
  genderfemale: "Nữ",
  phonenumberfill: "Số điện thoại di động:",
  birthplacefill: "Nơi sinh:",
  maritalfill: "Tình trạng hôn nhân:",
  singlemarital: "Độc thân",
  marriagemarital: "Đã kết hôn",
  occupationfill: "Nghề nghiệp:",
  idfill: "Số Căn cước công dân:",
  dateidfill: "Ngày cấp:",
  placeidfill: "Nơi cấp:",
  uploadidimage: "Tải ảnh CCCD (bắt buộc)",
  fontidimage: "Mặt trước",
  backidimage: "Mặt sau",
  emailfill: "Email:",
  addressfill: "Địa chỉ thường trú:",
  provincefill: "Tỉnh/ Thành phố:",
  districtfill: "Quận/ Huyện:",
  wardfill: "Phường/Xã:",
  roadfill: "Số nhà và tên đường:",
  addresscontactfill: "Địa chỉ liên hệ:",
  assuranceproductinformation: "Thông tin Sản phẩm bảo hiểm",
  assuranceproduct: "Sản phẩm bảo hiểm",
  expiredassurance: "Thời hạn hợp đồng",
  expiredfee: "Thời hạn đóng phí",
  frequencyfee: "Định kỳ đóng phí",
  invitecode: "Mã giới thiệu/ khuyến mại:",

  titleconfirminformation: "Thông tin cá nhân của Bên mua bảo hiểm, cũng là Người được bảo hiểm",

  pleasereaddocument: "Vui lòng xem các tài liệu sau:",
  ruleandpolicyproduct1: "Xin vui lòng đọc kỹ các nội dung cam kết dưới đây và ",
  ruleandpolicyproduct2: "Quy tắc và Điều khoản sản phẩm",
  ruleandpolicyproduct3: " của Hợp đồng Bảo hiểm này. Xin lưu ý rằng Quý khách không thể tiếp tục mà không đánh dấu vào ô dưới đây.",
  verifyOtp: "Xác nhận email",
  verifyOtp1: "Hãy nhập mã xác thực một lần (OTP) được gửi đến địa chỉ email ",
  verifyOtp2: " của bạn. ",
  verifyOtp3: "Mã xác thực có hiệu lực trong ",
  verifyotpack: "Xác thực thông tin và nhận Hợp đồng điện tử",
  changeEmail: "Thay đổi email",
  resendOtp: "Gửi lại mã xác thực",
  confirmOtp: "Xác nhận",
  otpexpired: "Mã xác thực hết hiệu lực",
  minute: " phút.",
  messagesuccessuploadimage: "Tải hình ảnh lên thành công",
  messagefailuploadimage: "Tải hình ảnh lên thất bại",
  messagewronguploadimage: "Vui lòng tải lên hình ảnh dạng .png, .jpg, .gif",
  messagebiguploadimage: "Vui lòng tải lên hình ảnh có dung lượng nhỏ hơn 10 MB",
  messagefillfullinformation: "Vui lòng điền đầy đủ thông tin để tiếp tục",
  btnpayment: "Thanh toán",
  warningfailiduser: "Đã tồn tại một HĐBH của sản phẩm này tương ứng với số CCCD của quý khách. Vui lòng kiểm tra lại",
  notenoughage: "Bạn phải từ đủ 18 tuổi trở lên và 60 tuổi trở xuống để đăng ký gói bảo hiểm này",
  sendotpphone:"Gửi OTP",
  verifyotpphone: "Xác nhận số điện thoại",
  verifyotpphone1: "Hãy nhập mã xác thực một lần (OTP) được gửi đến số điện thoại (Zalo hoặc SMS) ",
  verifyotpphonenewest1: "Hãy nhập mã xác thực một lần (OTP) được gửi đến số điện thoại (Zalo) ",
  verifyotpphonenewest2: "Hãy nhập mã xác thực một lần (OTP) được gửi đến số điện thoại (SMS) ",
  verifyotpphone2: " của bạn. ",
  verifyotpphone3: "Mã xác thực có hiệu lực trong ",
  verifysuccess: "Xác thực thành công",
  lostconection: "Mất kết nối đến hệ thống vui lòng thử lại sau",
  connectiontoolong:"Kết nối tới hệ thống không thành công, vui lòng thử lại sau",
  nulldata: "Dữ liệu trống",
  registersuccess: "Đăng ký thành công",
  errortrylater: "Đã có lỗi xảy ra, vui lòng thử lại sau",
  ekyclostconnect: "Không thể kết nối đến hệ thống Ekyc, vui lòng thử lại sau",
  errorlengthidnumber: "Vui lòng nhập CCCD chính xác 12 kí tự",
  errorlengthaddress: "Bạn đã nhập Số nhà và tên đường của Địa chỉ thường trú quá 60 ký tự, vui lòng nhập lại",
  erroronecharactercontactaddress: "Bạn đã nhập Số nhà và tên đường của Địa chỉ liên hệ chỉ có 1 từ, vui lòng nhập lại",
  erroronecharacteraddress: "Bạn đã nhập Số nhà và tên đường của Địa chỉ thường trú chỉ có 1 từ, vui lòng nhập lại",
  errorlengthcontactaddress: "Bạn đã nhập Số nhà và tên đường của Địa chỉ liên hệ quá 60 ký tự, vui lòng nhập lại",
  discount20: "Giảm 20%",
  feeorigin: "Phí gốc",
  feediscount: "Giá sau giảm",
  discount: "Giảm",
  percent: "%",
  agentcode: "Mã đại lý",
  agentcodenotexisted: "Mã đại lý giới thiệu không hợp lệ hoặc đại lý hiện không đủ điều kiện. Vui lòng kiểm tra và thử lại.",
  nullagentcode: "Mã đại lý trống",
  promotioncodenotmatch: "Mã khuyến mãi hiện tại không trùng khớp với quyền lợi bảo hiểm, vui lòng kiểm tra và chọn 'Xem phí bảo hiểm' để tiếp tục thao tác"
};

